namespace Ir.Components.Workbook.DrilldownFilters {

    interface IViewModel {
        visible: KnockoutComputed<boolean>;
        drilldownFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        applyFilters: DevExpress.ui.dxButton.Properties;
        scrollViewOptions: DevExpress.ui.dxScrollView.Properties;
        comparisonFilterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        hasComparisonFilters: KnockoutObservable<boolean>;

        isToolbar: KnockoutObservable<boolean>;
    }

    interface IParams {
        isToolbar: boolean;
    }
    
    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        this.isToolbar = ko.observable(params.isToolbar);
        this.visible = ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
            if (this()) {
                if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                    return this().drilldownManager.isDrilldown;
                }
            }

            return false;
        }, workbook.workbookConfig.activeTabOrWidget);

        this.drilldownFilterSection = {
            icon: "filter_alt",
            scope: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                return this() && this().tabType() == TabTypeEnum.Dashboard ? ContainerScopeEnum.Widget : ContainerScopeEnum.Report;
            }, workbook.workbookConfig.activeTab),
            filters: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                if (this()) {                    
                    if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                        return this().drilldownManager.getActiveDrillViewItem().filters;
                    }
                }

                return ko.observableArray([]);
            }, workbook.workbookConfig.activeTabOrWidget),
            isToolbar: params.isToolbar,
            isDrilldown: true,
            title: ko.computed(function () {
                return "Drilldown";
            }),
            onOrderChanged(filters) {
                //workbook.workbookConfig.workbookHelper.saveFiltersOrder(filters(), self.activeTab().tabType() === TabTypeEnum.Dashboard ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report);
            },
            disabled: ko.computed(function () {
                return workbook.workbookConfig.activeTabOrWidget().drilldownManager.activeDrilldownIndex() === 0;
            })
        };

        this.comparisonFilterSection = {
            scope: ko.computed(function () {
                return ContainerScopeEnum.ComparisonFilter;
            }),
            comparisonFilters: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                if (this()) {
                    if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                        let reportConfig = this().drilldownManager.activeReportConfig;
                        if (reportConfig) {
                            return reportConfig.comparisonFilters;
                        }
                    }
                }

                return ko.observableArray([]);
            }, workbook.workbookConfig.activeTabOrWidget),
            isComparisonFilter: true,
            isToolbar: params.isToolbar,
            isDrilldown: true,
            title: ko.computed(function () {
                return "Comparison Filters";
            }),
            addClearButtonsVisible: false
        };
        this.hasComparisonFilters = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            if (this()) {
                if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                    let reportConfig = this().drilldownManager.activeReportConfig;
                    if (reportConfig) {
                        return reportConfig.comparisonFilters().length > 0;
                    }
                }
            }

            return false;
        }, workbook.workbookConfig.activeTabOrWidget);

        this.applyFilters = {
            icon: "check",
            text: "Apply Filters",
            hint: "Apply drilldown filters",
            stylingMode: 'contained',
            type: 'danger',
            disabled: ko.computed(function () {
                return (self.drilldownFilterSection.filters()().filter(x => x.isDrilldown() && (x.added() || x.removed() || x.isDirty())).length === 0) &&
                    (self.comparisonFilterSection.comparisonFilters()().filter(x => x.isDirty()).length === 0);
            }) as any,
            width: params.isToolbar ? 110 : "100%",
            elementAttr: {
                class: `apply-drilldown-filter-button`,
            },
            onClick: function () {
                workbook.workbookConfig.filterHelper.updateDrilldownFilters();
            }
        };

        this.scrollViewOptions = {
            direction: params.isToolbar ? "horizontal" : "vertical",
            useNative: false
        };
    }
}